import { DEMO_PATH_PREFIX, LocalStorageKey } from '@/shared/config';

import { safeLocalStorage } from './safeLocalStorage';

// Shared demo credentials must not identify different visitors as one chat user.
export const markDemoSession = () => {
  safeLocalStorage.setItem(LocalStorageKey.demoSession, 'true');
};

export const clearDemoSession = () => {
  safeLocalStorage.removeItem(LocalStorageKey.demoSession);
};

export const isDemoSession = () =>
  safeLocalStorage.getItem(LocalStorageKey.demoSession) === 'true';

export const hasDemoPathPrefix = (pathname: string) =>
  pathname === DEMO_PATH_PREFIX || pathname.startsWith(`${DEMO_PATH_PREFIX}/`);

export const demoBasePath = () => (isDemoSession() ? DEMO_PATH_PREFIX : '');
